import {
  Article,
  ArticleAction,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { Button } from "@babackapp/customer-ui/components/button";
import { useAddLineItem } from "@babackapp/return-widget-components/hooks/use-add-line-item";
import type { OrderLineItem } from "@babackapp/return-widget-components/types";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatVariantOptions } from "../../utils/format-variant-options";

type LineItemRowProps = {
  lineItem: OrderLineItem;
  orderId: string;
  shopId: string;
};

export function LineItemRow({ lineItem, orderId, shopId }: LineItemRowProps) {
  const navigate = useNavigate();
  const addLineItem = useAddLineItem(orderId, shopId);

  const handleSelect = () => {
    addLineItem({
      lineItemId: lineItem.line_item_id,
      quantity: 1,
      reasonId: null,
      comment: null,
      imageUrls: [],
      resolution: null,
      resolutionOption: null,
      exchangeVariantId: null,
    });
    navigate(`${lineItem.line_item_id}/reason`);
  };

  const options = formatVariantOptions(lineItem);

  return (
    <Article onClick={handleSelect} className="cursor-pointer">
      <ArticleImage src={lineItem.image} layoutId={`img-${lineItem.line_item_id}`} />
      <ArticleTitle>{lineItem.title}</ArticleTitle>
      {options && <ArticleSubtitle>{options}</ArticleSubtitle>}
      <ArticleAction>
        <Button
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            handleSelect();
          }}
        >
          Retourner
          <ChevronRight />
        </Button>
      </ArticleAction>
    </Article>
  );
}
